var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noPermit-common"},[_c('span',{class:{ noWord: _vm.noWord }},[_vm._v(_vm._s(_vm.$t("edpBackendCommon.noPermssion")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }